// extracted by mini-css-extract-plugin
export var logo = "headerWithPartner-module--logo--90221";
export var logo__partner = "headerWithPartner-module--logo__partner--bb7a2";
export var phone = "headerWithPartner-module--phone--0c315";
export var topLogo = "headerWithPartner-module--top-logo--4f89e";